import { useMutation } from '@tanstack/react-query';
import {
  OilStoreService,
  UploadTransactionImageDto,
  UploadTransactionImageEntity,
} from 'services/openapi';

export type UploadOilStoreAvatarType = {
  param: UploadTransactionImageDto;
};

export const useUploadOilStoreLogoMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UploadTransactionImageEntity,
      Error,
      UploadOilStoreAvatarType & { file: File }
    >({
      mutationFn: (request: UploadOilStoreAvatarType) => {
        return OilStoreService.oilStoreControllerUploadOilStoreLogo(
          request.param,
        );
      },
      onSuccess: async (data, { file }) => {
        const { sasUrl } = data;

        try {
          const res = await fetch(sasUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
              'x-ms-blob-type': 'BlockBlob',
            },
            body: file,
          });

          if (!res.ok) {
            throw error;
          }

          return data;
        } catch (error) {
          throw error;
        }
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
